export default {
  navigationBarTitleText: ''
};
